export enum PhItemLinesSampleTypeEnum{
    SWATCH='SWATCH'
}